import React, { useState } from "react";
import styles from "./sidebar.module.scss";
import logo from 'assets/images/company-logo.png';
import { InterfaceNavLink } from "./navLink/navLink";
import TabIcon from "components/icons/tab";
import WatchLaterIcon from "components/icons/watchLater";
import BookmarkIcon from "components/icons/bookmarks";
import QuestionIcon from "components/icons/questionIcon";
import CallIcon from "components/icons/callIcon";
import { useSetAppState } from 'context/index';
import { useHistory, useLocation } from 'react-router-dom';
import { logoutUser, useGetUser } from "actions/userActions";
import ReviewQuestionniareIcon from "components/icons/reviewQuestionnaireIcon";
import ReviewApplicationIcon from "components/icons/reviewApplicationIcon";
import { isUserClient, isUserStandard } from "utils/userFunctions";
import { RoutePaths, StandardUserRoutePaths } from "app/routing/routing";
import MailIcon from "components/icons/mailIcon";
import { useGetIsHR } from "actions/contactActions";
import translations from "locales";

const Sidebar = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const setAppState = useSetAppState();
  const [showContactMenu, setShowContactMenu] = useState(false);
  const lang = localStorage.getItem('lang') || 'en';
  const {
    data: userInfo,
  } = useGetUser();
  const usrID = userInfo?.id ? parseInt(userInfo.id) : -1;
  const { isHR } = useGetIsHR({ usrID });

  const handleLogout = () => {
    logoutUser();
    setAppState({ Authenticated: false, Authenticating: false });
  };

  const toggleContactMenu = () => {
    setShowContactMenu(prev => !prev);
  };


  const getClientNavLinks = () => {
    if (isUserClient()) {
      return (
        <>
          <InterfaceNavLink 
            id="homeLink"
            to="" 
            activeLinks={[RoutePaths.Dashboard, RoutePaths.Company, RoutePaths.Application]} 
            icon={<TabIcon />} 
            iconClassName={styles.sideBarIcon}
          >{lang === 'fr' ? translations.fr.home : translations.en.home}</InterfaceNavLink>        
          <InterfaceNavLink 
            id="allMattersLink"
            to={RoutePaths.AllMatters} 
            activeLinks={[RoutePaths.AllMatters]}  
            icon={<BookmarkIcon />}  
            iconClassName={styles.sideBarIcon}
          >{lang === 'fr' ? translations.fr.all_matters : translations.en.all_matters}</InterfaceNavLink>
          {isHR && (
            <InterfaceNavLink 
              id="expiryDatesLink"
              to={RoutePaths.ExpiryDates} 
              activeLinks={[RoutePaths.ExpiryDates]}  
              icon={<WatchLaterIcon />} 
              iconClassName={styles.sideBarIcon}
            >
              {lang === 'fr' ? translations.fr.expiry_dates : translations.en.expiry_dates}
            </InterfaceNavLink>
          )}
          <div className={styles.sidebarLine}></div>
          <InterfaceNavLink 
            id="helpLink"
            to={RoutePaths.Help} 
            activeLinks={[RoutePaths.Help]} 
            icon={<QuestionIcon />} 
            iconClassName={styles.sideBarIcon}
          >{lang === 'fr' ? translations.fr.help_center : translations.en.help_center}</InterfaceNavLink>
          <div className={styles.sidebarPopoutBody}>
            <div onClick={toggleContactMenu}>
              <InterfaceNavLink
                id="contactLink"
                to="#"
                activeLinks={[]} 
                icon={<CallIcon />}
                iconClassName={styles.sideBarIcon}
              >{lang === 'fr' ? translations.fr.contact_us : translations.en.contact_us}</InterfaceNavLink>
            </div>
            {showContactMenu && (
              <div className={styles.sidebarPopout}>
                <div className={styles.sidebarPopoutTitle}>
                  {lang === 'fr' ? translations.fr.contact_It : translations.en.contact_It}
                </div>
                <div className={styles.sidebarPopoutRow}>
                  <CallIcon width="20" height="20" fill="#2a3192"/>
                  <a href="tel:14168633659" className={styles.sidebarPopoutLink}> +1-416-863-3659</a>
                </div>
                <div className={styles.sidebarPopoutRow}>
                  <MailIcon width="20" height="20" fill="#2a3192"/>
                  <a href="mailto:IT@gands.com" className={styles.sidebarPopoutLinkMail}>IT@gands.com</a>
                </div>
              </div>
            )}
          </div>
        </>
      );
    }
    if (isUserStandard()) {
      return (
        <>
          <InterfaceNavLink 
            id="questionnairesLink"
            to={StandardUserRoutePaths.ReviewQuestionnaires} 
            activeLinks={[StandardUserRoutePaths.ReviewQuestionnaires]} 
            icon={<ReviewQuestionniareIcon />} 
            iconClassName={styles.sideBarIcon}
          >{lang === 'fr' ? translations.fr.questionnaires : translations.en.questionnaires}</InterfaceNavLink>

          <InterfaceNavLink 
            id="newMattersLink"
            to={StandardUserRoutePaths.ReviewApplications}
            activeLinks={[StandardUserRoutePaths.ReviewApplications]} 
            icon={<ReviewApplicationIcon />} 
            iconClassName={styles.sideBarIcon}
          >New Matters</InterfaceNavLink>
        </>
      );
    }
    return null;
  };
  
  const navLinks = getClientNavLinks();

  return (
    <div className={styles.sidebar}>
      <h3 id="exitSideBar" className={styles.exitButton}>X</h3>
      <div className={styles.sidebarOptionsWrapper}>
        <div className={styles.topSidebar}>
          <img className={styles.companyLogo} src={logo} alt="" />
        </div>
        <div className={styles.topSidebarButtons}>
          {navLinks}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
